module.exports = __webpack_public_path__ + "img/69b51bc.jpg";